module.exports = __webpack_public_path__ + "img/3c4f60a.jpg";